import { useNavigation } from 'react-router';

import { useIsNavigatingAway } from '@jane/bloom/hooks/navigation/useIsNavigatingAway';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import {
  deriveBasename,
  stripBasename,
} from '@jane/bloom/utils/deriveBasename';

/**
 * @param {RegExp} pathPattern - Regex pattern to test pending navigation route against
 * @returns {boolean} whether the page is navigating to a location matching input regex
 */
export const useIsNavigatingTo = (pathPattern: RegExp): boolean => {
  const { menuUrl } = useRootLoaderData();
  // NB: destinationLocation contains the full path; it is *not* relative to React Router's route table.
  const { location: destinationLocation } = useNavigation();
  const isNavigatingAway = useIsNavigatingAway();
  return Boolean(
    isNavigatingAway &&
    stripBasename(destinationLocation?.pathname, deriveBasename(menuUrl)).match(
      pathPattern
    )
  );
};
